import { useEffect } from "react"

/**
 * Wires a paste handler that pulls images out of the clipboard and
 * forwards them to `onAttach`. Anchors to a target element (the
 * composer textarea) so paste only fires while focus is inside.
 */
export function usePasteAttach(
  target: HTMLElement | null,
  onAttach: (files: File[]) => void,
) {
  useEffect(() => {
    if (!target) return
    const handler = (e: ClipboardEvent) => {
      const items = e.clipboardData?.items
      if (!items) return
      const files: File[] = []
      for (let i = 0; i < items.length; i++) {
        const item = items[i]
        if (item.kind !== "file") continue
        const file = item.getAsFile()
        if (file && file.type.startsWith("image/")) files.push(file)
      }
      if (files.length > 0) {
        e.preventDefault()
        onAttach(files)
      }
    }
    target.addEventListener("paste", handler as EventListener)
    return () => target.removeEventListener("paste", handler as EventListener)
  }, [target, onAttach])
}
